<template>
    <component :is="tag">
        <slot v-bind="{ favoritesCount, favoritesData }" />
    </component>
</template>

<script>
export default {
    name: 'favorites-state-provider',
    inject: ['$favoritesService'],
    props: {
        tag: {
            type: String,
            default: 'span',
        },
    },
    computed: {
        favoritesData() {
            return this.$favoritesService.state.favoritesData;
        },
        favoritesCount() {
            return Object.values(this.favoritesData || {}).length;
        },
    },
};
</script>
